export const FSHomePageLightBoxActions = {
    SHOW: 'SHOW',
    HIDE: 'HIDE',
};
